
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { NpsService } from './nps.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { BaseComponent } from '../../../../shared/base.component';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../../home/home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import * as moment from 'moment';
import {B2CAdminComponent} from "../../b2c-admin.component";
import {MaintenanceComponent} from "../../../../maintenance/maintenance.component";
import {NpsMockup} from "./nps.interface";
import {NpsModel} from "./nps.model";
import * as Highcharts from 'highcharts';
import XrangeModule from 'highcharts/modules/xrange';
XrangeModule(Highcharts);

@Component({
    selector: 'nps-component',
    templateUrl: './nps.component.html',
    styleUrls: ['./nps.component.scss'],
    providers: [NpsService]
})

export class NpsComponent extends B2CAdminComponent implements OnInit, AfterViewInit {
    url = 'b2c-patients/nps';
    helpClinicProfile: any;
    @Input() isHome = false;
    @Input() filters;
    npsComments: any;
    userRoleId: number;
    isEditable: boolean = false;
    data: any;
    collapse = true;
    nps = new NpsMockup();
    color = {
        total : '#202A4D',
        res : '#59AD93',
        sub : '#FF6B92'
    };
    serviceMockup = [{
        service: 'Starter',
        paid : 3,
        completed: 16
    },
        {
            service: 'First Call Package (Appointment)',
            paid : 3,
            completed: 0
        }];
    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        ['patient_id', 'Patient Id', 'col-xs-3'],
        ['score', 'Score', 'col-xs-3'],
        ['comment', 'Comment', 'col-xs-3'],
        ['created_at', 'Created At', 'col-xs-3']
    ];
    response: any;

    Highcharts: typeof Highcharts = Highcharts;
    chartConstructor: string = 'chart'; // optional string, defaults to 'chart'
    chartCallback: Highcharts.ChartCallbackFunction = function (chart) {  } // optional function, defaults to null
    chartOptions: Highcharts.Options = {};
    // Pie Chart data
    chartTypes = [
        {
            type: 'column',
            name: this.translate.instant('Net Promoter Score'),
            options: this.chartOptions,
            data: []
        },
    ];
    loadedData = false;
    chartGenerated = false;
    plotOptions: {};

    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent,
                public service: NpsService)  {
        super(authService, coreService, router, translate, fb, baseService, appService, usersService, homeService, clinicService, maintenanceService, secureApi, maintenanceComponent);
    }

    ngOnInit() {
        super.ngOnInit();

        this.userRoleId = this.authService.user['role_id'];
        this.searchInfo = new NpsModel();
        this.sortedColumn = 'started';
        this.token = this.authService.user['token'];

        // sort
        this.initSorting();
        if(!this.isHome){
            return this.getItems();
        }
    }

    ngAfterViewInit() {
    }

    /**
     * preload mobile number for mobile field
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    getItems() {
        this.initPageSize(this.isHome);
        // this.dateOptionFilter.from = this.dateOptionFilter.from
        this.service.getAll(this.filters).subscribe(response => {
            this.isLoading = false;
            this.nps = response['nps'];
            this.npsComments = response['items'] || [];
            this.items = response['items'] || [];
            return this.setData(response);
        });
    }

    getRandomInt(min, max) {
        const minCeiled = Math.ceil(min);
        const maxFloored = Math.floor(max);
        return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
    }

    setData(data: any): void {
        this.data =  data;

        for(let chart of this.chartTypes){
            let chartData = [];
            for(let i = 0; i<= 10; i++ ){
                let iCount = _.filter(this.npsComments, function(item){
                    return item.score === i;
                });
                let item = {
                    x: i,
                    y: iCount ? iCount?.length : 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.0f}',
                        style: {
                            fontSize: '12px' // Adjust the y-axis labels font size
                        }
                    },
                };
                chartData.push(item);
            }
            const seriesData: Highcharts.SeriesColumnOptions = {
                type: 'column',
                name: this.translate.instant('Number of votes'),
                data: chartData,
                showInLegend: false,
                colorByPoint: true,
                pointPadding: 0.1 // Adjust the padding between columns as needed
            };
            chart.options = {
                chart: {
                    type: 'column'
                },
                title: {
                    text: this.translate.instant(chart['name'])
                },
                colors: ['#3C6973','#3C6973','#3C6973','#3C6973','#3C6973','#3C6973','#3C6973', '#2E4960', '#2E4960', '#1F294C', '#1F294C'],
                xAxis: {
                    crosshair: true,
                    labels: {
                        style: {
                            fontSize: '12px' // Adjust the y-axis labels font size
                        }
                    },
                    categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
                },
                yAxis: {
                    title: {
                        text: this.translate.instant('Number of votes')
                    },
                    labels: {
                        style: {
                            fontSize: '12px' // Adjust the y-axis labels font size
                        }
                    },
                },
                tooltip: {
                    shared: true
                },
                series: [seriesData]
            }
        }

        return this.generateHighChart();
    }

    generateHighChart(){
        // if appointments are empty, hide the page numbers below the appointments list to prevent page redirection
        this.paginationHidden = this.npsComments.length === 0;
        this.chartGenerated = true;
    }

    sortData(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false, this.sortUsingApi);
    }
}
